// Import model
import { LaminatesCatalogItemCondition } from '../models/LaminatesCatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { LaminatesCatalogItemIndexedFields } from '../models/LaminatesCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { LaminatesCatalogItemIndexedFieldsSerializer } from './LaminatesCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LaminatesCatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class LaminatesCatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a LaminatesCatalogItemCondition instance
   */
  static deserialize(json: string): LaminatesCatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LaminatesCatalogItemCondition instance
   */
  static fromObject(obj: any): LaminatesCatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LaminatesCatalogItemCondition');
    }


    const instance: LaminatesCatalogItemCondition = {
      fieldName: obj['fieldName'] as LaminatesCatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LaminatesCatalogItemCondition instances
   */
  static deserializeArray(json: string): LaminatesCatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LaminatesCatalogItemCondition instance to a JSON string
   */
  static serialize(instance: LaminatesCatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LaminatesCatalogItemCondition instance to a plain object
   */
  static toObject(instance: LaminatesCatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of LaminatesCatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: LaminatesCatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
